var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    { ref: "costConfigForm", attrs: { name: "costConfigForm" } },
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            title: _vm.$t("Dados da configuração de custo"),
            "no-actions": "",
            "show-loading": _vm.saving,
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "cost-config-name",
                      label: _vm.$t("Nome"),
                      name: "name",
                      type: "text",
                      validation: "required",
                      instruction: _vm.$t(
                        "Identifica o contrato negociado com a adquirente"
                      ),
                    },
                    model: {
                      value: _vm.formCostConfig.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formCostConfig, "name", $$v)
                      },
                      expression: "formCostConfig.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "cost-config-acquirer",
                      label: _vm.$t("Adquirente"),
                      name: "acquirer",
                      type: "vue-select",
                      validation: "required",
                      placeholder: _vm.$t("Selecione"),
                      options: _vm.acquirerOptions(),
                    },
                    model: {
                      value: _vm.formCostConfig.acquirer,
                      callback: function ($$v) {
                        _vm.$set(_vm.formCostConfig, "acquirer", $$v)
                      },
                      expression: "formCostConfig.acquirer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "cost-config-effective-from",
                      label: _vm.$t("Vigente de"),
                      name: "effectiveFrom",
                      type: "datepicker",
                    },
                    model: {
                      value: _vm.formCostConfig.effectiveFrom,
                      callback: function ($$v) {
                        _vm.$set(_vm.formCostConfig, "effectiveFrom", $$v)
                      },
                      expression: "formCostConfig.effectiveFrom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "cost-config-effective-to",
                      label: _vm.$t("Vigente até"),
                      name: "effectiveTo",
                      type: "datepicker",
                    },
                    model: {
                      value: _vm.formCostConfig.effectiveTo,
                      callback: function ($$v) {
                        _vm.$set(_vm.formCostConfig, "effectiveTo", $$v)
                      },
                      expression: "formCostConfig.effectiveTo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "p",
                  { staticClass: "text-muted mb-0" },
                  [
                    _c("feather-icon", { attrs: { icon: "InfoIcon" } }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "O custo financeiro de uma venda é o custo de operação mais o custo de antecipação de todas as parcelas. Por isso ele cresce com a quantidade de parcelas mesmo com o custo de operação fixo."
                          )
                        ) +
                        " "
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.channels, function (channel) {
        return _c(
          "b-card-actions",
          {
            key: channel.key,
            attrs: {
              title: channel.title,
              "no-actions": "",
              "show-loading": _vm.saving,
            },
          },
          [
            _c(
              "b-row",
              [
                _c("b-col", [
                  _c(
                    "p",
                    { staticClass: "text-muted" },
                    [
                      _c("feather-icon", { attrs: { icon: "InfoIcon" } }),
                      _vm._v(" " + _vm._s(channel.hint) + " "),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "4" } },
                  [
                    _c("FormulateInput", {
                      staticClass: "required",
                      attrs: {
                        id: "cost-config-" + channel.key + "-operation-cash",
                        label: _vm.$t("Custo de operação - à vista (%)"),
                        name: channel.key + "OperationCostCashPercent",
                        type: "text-number",
                        precision: 4,
                        suffix: " %",
                        validation: "required",
                        instruction: _vm.$t(
                          "Percentual cobrado sobre o total da venda paga em uma única parcela"
                        ),
                      },
                      model: {
                        value:
                          _vm.formCostConfig[channel.key]
                            .operationCostCashPercent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formCostConfig[channel.key],
                            "operationCostCashPercent",
                            $$v
                          )
                        },
                        expression:
                          "formCostConfig[channel.key].operationCostCashPercent",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { md: "4" } },
                  [
                    _c("FormulateInput", {
                      staticClass: "required",
                      attrs: {
                        id:
                          "cost-config-" +
                          channel.key +
                          "-operation-installment",
                        label: _vm.$t("Custo de operação - parcelado (%)"),
                        name: channel.key + "OperationCostInstallmentPercent",
                        type: "text-number",
                        precision: 4,
                        suffix: " %",
                        validation: "required",
                        instruction: _vm.$t(
                          "Percentual cobrado sobre o total da venda paga em duas ou mais parcelas"
                        ),
                      },
                      model: {
                        value:
                          _vm.formCostConfig[channel.key]
                            .operationCostInstallmentPercent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formCostConfig[channel.key],
                            "operationCostInstallmentPercent",
                            $$v
                          )
                        },
                        expression:
                          "formCostConfig[channel.key].operationCostInstallmentPercent",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { md: "4" } },
                  [
                    _c("FormulateInput", {
                      staticClass: "required",
                      attrs: {
                        id: "cost-config-" + channel.key + "-anticipation",
                        label: _vm.$t("Custo de antecipação ao mês (%)"),
                        name: channel.key + "AnticipationCostMonthlyPercent",
                        type: "text-number",
                        precision: 4,
                        suffix: " %",
                        validation: "required",
                        instruction: _vm.$t(
                          "Percentual ao mês cobrado por parcela, proporcional ao prazo até o seu recebimento"
                        ),
                      },
                      model: {
                        value:
                          _vm.formCostConfig[channel.key]
                            .anticipationCostMonthlyPercent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formCostConfig[channel.key],
                            "anticipationCostMonthlyPercent",
                            $$v
                          )
                        },
                        expression:
                          "formCostConfig[channel.key].anticipationCostMonthlyPercent",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm.isEdition
        ? _c(
            "b-card-actions",
            {
              attrs: {
                title: _vm.$t("Simulação de custo"),
                "no-actions": "",
                "show-loading": _vm.simulating,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "mb-1" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "simulation-sale-value",
                          label: _vm.$t("Valor de referência"),
                          name: "simulationSaleValue",
                          type: "text-number",
                          currency: "R$",
                          precision: 2,
                        },
                        model: {
                          value: _vm.localSimulationValue,
                          callback: function ($$v) {
                            _vm.localSimulationValue = $$v
                          },
                          expression: "localSimulationValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "simulation-channel",
                          label: _vm.$t("Canal"),
                          name: "simulationChannel",
                          type: "vue-select",
                          clearable: false,
                          options: _vm.channelOptions,
                          instruction: _vm.$t(
                            "As taxas variam entre presencial e online"
                          ),
                        },
                        model: {
                          value: _vm.localSimulationChannel,
                          callback: function ($$v) {
                            _vm.localSimulationChannel = $$v
                          },
                          expression: "localSimulationChannel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex align-items-end pb-1",
                      attrs: { md: "3" },
                    },
                    [
                      _c("e-button", {
                        attrs: {
                          text: _vm.$t("Simular"),
                          variant: "primary",
                          busy: _vm.simulating,
                        },
                        on: { click: _vm.runSimulation },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-table", {
                staticClass: "bordered",
                attrs: {
                  "show-empty": "",
                  responsive: "",
                  striped: "",
                  small: "",
                  "empty-text": _vm.$t("Informe um valor e clique em Simular"),
                  fields: _vm.simulationFields,
                  items: _vm.simulationLines,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(installments)",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.item.installments) + "x "),
                          row.item.usesCashOperationCost
                            ? _c(
                                "b-badge",
                                {
                                  staticClass: "ml-50",
                                  attrs: { variant: "light-info" },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("à vista")) + " ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3523220242
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("e-crud-actions", {
        attrs: { busy: _vm.saving },
        on: { save: _vm.saveCostConfig, cancel: _vm.cancel },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }